
export function calculateTotalCents(items) {

    let totalCents = 0

    items.forEach(item => {
        const quantity = parseInt(item.quantity)
        const priceDecimal = parseFloat(item.price)
        let priceCents = 0
        if(priceDecimal) { priceCents = parseInt((parseFloat(item.price.replace(/,/g, '')).toFixed(2) * 100.00).toFixed(0)) }

        totalCents = totalCents + (quantity * priceCents)
    })

    return totalCents
}

export function cleanItems(items) {
    let finalItems = [];

    items.forEach(item => {

        let newItem = {
            quantity: parseInt(item.quantity, 10), // convert to integer
            itemCostCents: parseInt(
                (parseFloat(item.price.replace(/,/g, '')).toFixed(2) * 100).toFixed(0),
                10
            ),
            equipment: parseInt(item.id, 10) // convert to integer
        };

        finalItems.push(newItem);
    });

    return finalItems;
}
